import { createFileRoute, redirect } from '@tanstack/react-router';

const domain = import.meta.env.VITE_AUTH0_DOMAIN || '';
const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID || '';

export const Route = createFileRoute('/sign-up')({
  beforeLoad: () => {
    const params = new URLSearchParams({
      client_id: clientId,
      response_type: 'code',
      redirect_uri: window.location.origin,
      scope: 'openid profile email',
      screen_hint: 'signup',
    });

    const signupUrl = `https://${domain}/authorize?${params.toString()}`;

    throw redirect({ href: signupUrl });
  },
});
